import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import PropTypes from 'prop-types'

import permutationTextMapping from './configs/permutationTextMapping'
import PermutationDots from './helpers/PermutationDots'

const Row = styled.div`
  display: grid;
  grid-template-columns: .2fr 1fr 1fr 1fr;
  padding: 10px 0px;
  &:nth-of-type(even) {
    background: #f4f4f4;
  }
`
const Cell = styled.div`
  display: flex;
  align-items: center;
  justify-self: center;
  justify-content: center;
  text-align: center;
  font-size: 14px;
`
const getSourceText = permutation => {
  return permutationTextMapping[permutation]
}

const SmartRateRow = ({ predictionResult }) => {
  const { smartRate, predictionModel, createdAt } = predictionResult
  const { dataPermutation } = predictionModel
  return (
    <Row>
      <Cell>
        <PermutationDots color="grey" dataPermutation={dataPermutation} />
      </Cell>
      <Cell>
        {getSourceText(dataPermutation)}
      </Cell>
      <Cell>
        {smartRate}
      </Cell>
      <Cell>
        {moment(createdAt).format('MM/DD/YYYY')}
      </Cell>
    </Row>
  )
}

SmartRateRow.propTypes = {
  predictionResult: PropTypes.shape({
    createdAt: PropTypes.string,
    predictionModel: PropTypes.shape({
      dataPermutation: PropTypes.string
    }),
    smartRate: PropTypes.number
  })
}

export default SmartRateRow
